export const SET_MACHINESTANDSTILLINFO = 'SET_MACHINESTANDSTILLINFO';